

export function checkMobilePhone() {
    
    const userAgent = navigator.userAgent;
	return userAgent.match(/(iPhone|iPod|Android|ios|iPad|AppleWebKit.*Mobile.*)/i);

}